import { Content } from './types'

const listItem: Content = {
    type: 'listItem',
    name: 'Lijst item',
}

export default listItem
